module.exports = __webpack_public_path__ + "static/media/reva_p.fbec476e.JPG";